export default __webpack_public_path__ + "img/dMwmjSLr.3625e088.svg";